"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var defaultArrayPrefixFn = function (parentProp, currIndex) { return "".concat(parentProp, "[").concat(currIndex, "]"); };
var defaultObjPrefixFn = function (parentProp, childProp) { return "".concat(parentProp, ".").concat(childProp); };
exports.default = (function (startingData, _objPrefixFn, _arrayPrefixFn, rootPathPrefix) {
    if (rootPathPrefix == null) {
        rootPathPrefix = "";
    }
    var flattenJson = function (data) {
        var result = {};
        var objPrefixFn = _objPrefixFn !== null && _objPrefixFn !== void 0 ? _objPrefixFn : defaultObjPrefixFn;
        var arrayPrefixFn = _arrayPrefixFn !== null && _arrayPrefixFn !== void 0 ? _arrayPrefixFn : defaultArrayPrefixFn;
        var recurse = function (current, prop) {
            var e_1, _a;
            if (Object(current) !== current) {
                result[prop] = current;
            }
            else if (lodash_1.default.isDate(current)) {
                result[prop] = current.toString();
            }
            else if (lodash_1.default.isArray(current)) {
                for (var index = 0; index < current.length; index++) {
                    var divider = void 0;
                    if (prop) {
                        divider = arrayPrefixFn(prop, index);
                    }
                    else {
                        divider = "".concat(current[index]);
                    }
                    recurse(current[index], divider);
                }
                if (current.length === 0) {
                    result[prop] = [];
                }
            }
            else {
                var isEmpty = true;
                try {
                    for (var _b = __values(Object.keys(current)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        var prefix = void 0;
                        isEmpty = false;
                        if (prop) {
                            prefix = objPrefixFn(prop, item);
                        }
                        else {
                            prefix = item;
                        }
                        recurse(current[item], prefix);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                if (isEmpty) {
                    result[prop] = {};
                }
            }
        };
        recurse(data, "");
        return result;
    };
    var addRootPathPrefix = function (data, prefix) {
        var e_2, _a;
        if (prefix.slice(-1) !== ".") {
            prefix += ".";
        }
        var prefixed = {};
        try {
            for (var _b = __values(Object.keys(data)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var path = _c.value;
                var value = data[path];
                prefixed[prefix + path] = value;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return prefixed;
    };
    var flattened = flattenJson(startingData);
    if (rootPathPrefix != null ? rootPathPrefix.length : undefined) {
        flattened = addRootPathPrefix(flattened, rootPathPrefix);
    }
    return flattened;
});
